export default __webpack_public_path__ + "static/media/logo.7f5e54a8.png";